var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "btn-group" },
    [
      _c("el-tooltip", { attrs: { content: "Revert", placement: "top" } }, [
        _vm.canRevert && _vm.isRevertable
          ? _c(
              "button",
              {
                staticClass: "btn btn-warning btn-sm",
                on: { click: _vm.confirmReverting },
              },
              [_c("i", { staticClass: "fas fa-reply" })]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }